import { client, type ClientId } from '@atlassian/rovo-content-bridge-api/client-types';

export const ROVO_EXTENSION_CLIENT_ID: ClientId = client('rovo-extension');
